import React from 'react';
import { getInventaireGridClassName, InventaireViewMode } from '../utils/inventaireViewMode';

interface ResponsiveGridProps {
  children: React.ReactNode;
  viewMode: InventaireViewMode;
  className?: string;
}

const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({ children, viewMode, className = '' }) => {
  return <div className={`${getInventaireGridClassName(viewMode)} ${className}`.trim()}>{children}</div>;
};

export default ResponsiveGrid;
